// extracted by mini-css-extract-plugin
export var loader = "buttonLoader-module--loader--4a24b";
export var spin = "buttonLoader-module--spin--c5710";